export const FILTER_TYPES = {
    PLATFORM: 'platform',
    TERRITORY: 'territory',
    LABEL: 'label',
    ARTIST: 'artist',
    RELEASE: 'release',
    TRACK: 'track'
} as const;

type FilterType = typeof FILTER_TYPES[keyof typeof FILTER_TYPES];

interface IFilterConfig {
    placeholderId: string;
    defaultPlaceholder: string;
    filterPlaceholder: string;
    filterKey: keyof import('../../hooks/useAnalytics').IFilters;
}

type FilterConfigMap = {
    [K in FilterType]: IFilterConfig;
};

export const getFilterConfig = (type: FilterType): IFilterConfig => {
    const configs: FilterConfigMap = {
        [FILTER_TYPES.PLATFORM]: {
            placeholderId: "Analytics.Filters.DSPPlaceholder",
            defaultPlaceholder: "DSP",
            filterPlaceholder: "Search DSPs",
            filterKey: 'filterPlatformIds'
        },
        [FILTER_TYPES.TERRITORY]: {
            placeholderId: "Analytics.Filters.TerritoryPlaceholder",
            defaultPlaceholder: "Territory",
            filterPlaceholder: "Search territories",
            filterKey: 'filterTerritoryIds'
        },
        [FILTER_TYPES.LABEL]: {
            placeholderId: "Analytics.Filters.LabelPlaceholder",
            defaultPlaceholder: "Label",
            filterPlaceholder: "Search labels",
            filterKey: 'filterLabelIds'
        },
        [FILTER_TYPES.ARTIST]: {
            placeholderId: "Analytics.Filters.ArtistPlaceholder",
            defaultPlaceholder: "Artist",
            filterPlaceholder: "Search artists",
            filterKey: 'filterArtistIds'
        },
        [FILTER_TYPES.RELEASE]: {
            placeholderId: "Analytics.Filters.ReleasePlaceholder",
            defaultPlaceholder: "Release",
            filterPlaceholder: "Search releases",
            filterKey: 'filterReleaseIds'
        },
        [FILTER_TYPES.TRACK]: {
            placeholderId: "Analytics.Filters.TrackPlaceholder",
            defaultPlaceholder: "Track",
            filterPlaceholder: "Search tracks",
            filterKey: 'filterTrackIds'
        }
    };

    return configs[type];
};